import gql from 'graphql-tag';

export default gql`
  query GetStakeholder(
    $id: ID!
  ) {
    stakeholder(id: $id) {
      createdAt
      id
      updatedAt
      firstName
      lastName
      dob
      country
      homeNumber
      cellNumber
      email
      idNumber
      residentialAddress
      postalAddress
      unitNumber
      status
      role
      vmsTag
      image {
        id
        original
        scaled
        thumbnail
      }
      documents {
        id
        name
        status
        file {
          id
          original
          scaled
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/queries/GetStakeholder.ts